export const unknownServerErrorMessage = 'Server error. Please try to repeat operation later';
export const unknownFrontErrorMessage = 'Unknown error. Please try to repeat operation later';
export const unknownFileErrorMessage = 'Unknown error. Please try to repeat operation later or check the file';
export const validFileErrorMessage = 'Please add a valid file';
export const emptyNoteAddErrorText = 'Please enter note text';
export const removingFileErrorText = 'Something went wrong, the file was not removed';
